import { Button } from "antd";
import { IconClose } from "../Icons/IconClose";
import { IconSearch } from "../Icons/IconSearch";

interface Search extends React.InputHTMLAttributes<HTMLInputElement> {
  onClick: () => void;
  placeholder: string;
  value: string;
  onCancel: () => void;
  width?: string;
}

export function SimpleFilter(props: Search) {
  return (
    <div className="flex gap-0">
      <div className={`border-solid border-[1px] flex flex-row ${props.width ? props.width : 'w-[25rem]'} h-10 justify-between items-center px-2 border-gray-300 rounded-l-md focus:outline-none`}>
        <input
          {...props}
          className="w-[20rem] focus:outline-none"
          placeholder={props.placeholder}
          onKeyPress={function(e) {
            if(e.key === "Enter") {
              props.onClick()
            }
          }}
        />
        {
          props.value &&
          <Button 
            className="border-none focus:outline-none pl-2"
            icon={<IconClose width="20" height="20"/>}
            onClick={props.onCancel}
          />
        }
      </div>
      <Button
        onClick={props.onClick}
        className="h-10 rounded-r-md focus:outline-none">
        <IconSearch color="#858E96" />
      </Button>
    </div>
  );
}
